(() => {
  const initialize = () => {
    const root = document.getElementById('dorsea-home');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('dh-pending');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.06 });
      root.querySelectorAll('.dh-reveal').forEach(element => {
        if (element.getBoundingClientRect().top > window.innerHeight) element.classList.add('dh-pending');
        observer.observe(element);
      });
      // Always expose content for find-in-page, focus and theme editing.
      root.addEventListener('focusin', event => event.target.closest('.dh-pending')?.classList.remove('dh-pending'));
      document.addEventListener('shopify:section:select', () => root.querySelectorAll('.dh-pending').forEach(el => el.classList.remove('dh-pending')));
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
